<!--
    校区管理-代理商列表
    作用：代理商列表数据、启用禁用代理商、查看邀请码、关联校区
-->
<template>
  <div class="factor">
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      api="/api/service/operate/agent/list">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">启用</span>
              <span v-else>禁用</span>
              <el-switch
                :value="scope.row.status === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchStatus(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="230px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="InvitationCode(scope.row)"
              >邀请码</el-button>
              <el-button
                size="small"
                @click="relevanceCampus(scope.row)"
              >关联校区</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      :visible.sync="dialogVisible"
      title="邀请码"
      class="code_dialog"
      width="800px">
      <el-row class="main">
        <el-col :span="12">
          <el-form label-width="100px">
            <el-form-item label="代理商名字：">{{ invitationCode.name }}</el-form-item>
            <el-form-item label="邀请码：">{{ invitationCode.code }}</el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="createPoster">生成海报</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <div
            v-show="show"
            class="box">
            <div
              id="posterHtml"
              ref="posterHtml"
              class="posterHtml">
              <div class="name">{{ invitationCode.name }}</div>
              <div class="code">
                <h1>您的邀请码</h1>
                <div class="info">{{ invitationCode.code }}</div>
              </div>
              <div class="qrcode">
                <div
                  id="qrcodeImg"
                  ref="qrCodeUrl"/>
              </div>
            </div>
            <div class="poster">
              <img
                ref="posterImg"
                :src="posterImg"
                alt="">
            </div>
            <el-button
              type="primary"
              size="small"
              @click="copy">复制</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import html2canvas from 'html2canvas';

export default {
  name: 'Factor',
  inject: ['reload'],
  data() {
    return {
      list: {},
      columns: [
        { prop: 'name', label: '代理商' },
        { prop: 'mobile', label: '电话' },
        { prop: 'invitation_total', label: '关联校区数量' },
      ],
      isCreated: true,
      dialogVisible: false,
      posterImg: '',
      show: false,
      invitationCode: {
        name: '',
        code: '',
      },
    };
  },
  computed: {
    searchArr() {
      const column = [
        { prop: 'name', label: '代理商名称' },
        { prop: 'mobile', label: '手机号' },
      ];
      return [
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
  },
  methods: {
    // 修改禁用状态
    switchStatus(row) {
      console.log(row);
      const status = {
        status: row.status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改状态吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/service/operate/agent/update/status/${row.users_id}`, status)
            .then((res) => {
              this.$message.success('状态修改成功');
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        });
    },
    // 关联校区
    relevanceCampus(row) {
      this.$router.push(`/factor/relevance-campus/${row.users_id}/${row.name}?page=1&per_page=10&order[id]=desc`);
    },
    // 邀请码
    InvitationCode(row) {
      this.dialogVisible = true;
      this.show = false;
      this.invitationCode.code = row.invitation_code;
      this.invitationCode.name = row.name;
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = '';
      });
    },
    // 生成海报
    createPoster() {
      this.show = true;
      this.$refs.qrCodeUrl.innerHTML = '';
      this.$nextTick(() => {
        // 生成二维码
        const qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: `${this.$domain.h5}/bind_invitation_code/#?code=${this.invitationCode.code}&name=${this.invitationCode.name}`, // 需要转换为二维码的内容
          width: 250,
          height: 250,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
        // 生成海报
        html2canvas(this.$refs.posterHtml, {
          ogging: true, // 启用日志记录以进行调试 (发现加上对去白边有帮助)
          allowTaint: true, // 否允许跨源图像污染画布
          backgroundColor: null, // 解决生成的图片有白边
          useCORS: true, // 如果截图的内容里有图片,解决文件跨域问题
        }).then((canvas) => {
          this.posterImg = canvas.toDataURL('image/png');
        });
      });
    },
    // 复制
    copy() {
      this.$message.error('当前浏览器不支持复制功能，请手动点击右键进行复制！');
    },
  },
};
</script>

<style scoped lang="scss">
  .factor {
    #posterHtml {
      position: fixed;
      left: -99999px;
      top: 0;
    }
    .posterHtml {
      width: 750px;
      height: 1334px;
      background: url("../../../assets/images/invitation_code_bg.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .name {
        font-size: 28px;
        color: #B0583D;
        display: block;
        height: 54px;
        line-height: 54px;
        padding: 0 22px;
        background: #FFDC57;
        border-radius: 100px 100px 100px 0;
        position: absolute;
        left: 50%;
        top: 225px;
        transform: translate(-50%, 0);
      }
      .code {
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        top: 776px;
        h1 {
          font-size: 32px;
          color: #452113;
          font-weight: normal;
        }
        .info {
          display: inline-block;
          height: 73px;
          line-height: 73px;
          background: #F07300;
          padding: 0 50px;
          font-size: 32px;
          color: #fff;
        }
      }
      .qrcode {
        width: 300px;
        height: 300px;
        padding: 25px;
        box-sizing: border-box;
        border-radius: 26px;
        background: #fff;
        position: absolute;
        left: calc(50% - 150px);
        bottom: 70px;
        /deep/
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .poster {
      width: 250px;
      margin-bottom: 20px;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/factor/index.vue